import CryptoJS from 'crypto-js';

const TOKEN_P1 = 'llsa';
const TOKEN_P2 = '12l1';
const TOKEN_P3 = '332s';

export const getEncryptTimestamp = () => {
    const date = new Date();
    const localeString = date.toLocaleString('en-US', {
        timeZone: 'Asia/Singapore',
    });
    return new Date(localeString).getTime().toString();
};

export const decryptResponseData = <T>(response: string, timestamp: string): T => {
    // If response is already a JSON object, return it directly
    if (typeof response === 'object') {
        return response;
    }

    // If it's a string, try to decrypt first
    try {
        const token = `${TOKEN_P1}-${TOKEN_P2}-${TOKEN_P3}`;
        const key = `${token},${timestamp}`;
        const bytes = CryptoJS.AES.decrypt(response, key);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch {
        // If decryption fails, treat as regular JSON
        return JSON.parse(response);
    }
};
